import { render, staticRenderFns } from "./ResearchStudent.vue?vue&type=template&id=e5eb7c5a&"
import script from "./ResearchStudent.vue?vue&type=script&lang=js&"
export * from "./ResearchStudent.vue?vue&type=script&lang=js&"
import style0 from "./ResearchStudent.vue?vue&type=style&index=0&id=e5eb7c5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports